import {
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IItem } from "../../model";
import { sortBy } from "../../utils";
import { PisCofinsStore } from "../../stores/legislacao/PisCofinsStore";
import { Autocomplete, TextField } from "@mui/material";

interface Props {
  value: number[];
  onChange(value: string[]): void;
}

interface State { }

@observer
export class PisCofinsMultiSelect extends React.Component<Props, State> {

  obs = observable({
    value: [] as IItem[],
    isOpen: false as boolean,
    filter: "" as string,
  })

  constructor(props: Props) {
    super(props);
  }

  async componentDidMount() {

    this.updateValues()

  }

  updateValues() {

    this.obs.value = [];

    this.props.value?.forEach(codigo => {

      let produto = PisCofinsStore.get(codigo);

      if (produto) {

        this.obs.value.push(produto);

      }

    });

    this.obs.value = sortBy(this.obs.value, "codigo");

    this.props.onChange(this.obs.value?.map(p => p.codigo));

  }

  handleRemove(item: IItem) {

    let idx = this.obs.value.findIndex(x => x.codigo == item.codigo);

    if (idx != -1) {

      this.obs.value.splice(idx, 1);

    }

    this.props.onChange(this.obs.value?.map(p => p.codigo));

  }

  handleSelect = (event, newValue: IItem) => {

    if (newValue) {

      if (!this.obs.value.find(x => x.codigo == newValue.codigo)) {

        this.obs.value.push(newValue);

        this.props.onChange(this.obs.value?.map(p => p.codigo));

      }

    }

  };

  render() {

    let items = this.obs.value;

    if (this.obs.filter) {
      items = items.filter(x =>
        x.descricao.toUpperCase().indexOf(this.obs.filter.toUpperCase()) != -1 ||
        x.codigo.toUpperCase().indexOf(this.obs.filter.toUpperCase()) != -1
      );
    }

    let rows = this.obs.value?.map(value => {
      return (
        <tr key={value.id}>
          <td>{value.codigo}</td>
          <td>{value.descricao}</td>
          <td>{<img src="/images/bin.png" width={20} onClick={this.handleRemove.bind(this, value)} style={{ cursor: "pointer" }} />}</td>
        </tr>
      );
    });

    const itens = PisCofinsStore.obs.pis_cofins.filter(item =>

      !this.obs.value.some(selecionado => selecionado.codigo === item.codigo)

    );

    return (
      <>
        <div style={{ display: "flex", alignItems: "center" }}>

          <div style={{ width: 600 }}>
            <FormGroup className="">
              <Autocomplete
                disablePortal
                size="small"
                options={itens}
                getOptionLabel={(option) => `${option.codigo} - ${option.descricao}` || ""}
                onChange={this.handleSelect.bind(this)}
                renderInput={(params) => <TextField {...params} placeholder="Selecione um PIS-COFINS" />}
                value={null}
                className='select-empresas'
                clearOnBlur
                clearOnEscape
                blurOnSelect
                noOptionsText="Item já adicionado ou não encontrado!"
              />
            </FormGroup>
          </div>

          <FormGroup label="">
            <InputGroup
              style={{ marginLeft: 10, width: 200 }}
              placeholder="Filtrar (Código, Descrição)"
              value={this.obs.filter}
              onChange={(e: any) => this.obs.filter = e.target.value}
            />
          </FormGroup>

        </div>

        <div style={{ marginTop: 15, marginBottom: 15 }}>
          {this.obs.value.length} itens selecionado(s)
        </div>

        <div className="table-container">
          <table className="table table-hover dataTable custom-table">
            <thead className="sticky-header">
              <tr>
                <th className="column-width-code">CÓDIGO</th>
                <th className="column-width-description">DESCRIÇÃO</th>
                <th className="column-width-code" />
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}
